import { ROLES, type Order, type Role } from "../shared/order-domain";

export type OrderFilter = "all" | "unprinted" | "untransferred";

export interface AppState {
  orders: Order[];
  filter: OrderFilter;
  search: string;
  loading: boolean;
  role: Role | null;
  roleLabel: string;
}

export const state: AppState = {
  orders: [],
  filter: "all",
  search: "",
  loading: true,
  role: null,
  roleLabel: "",
};

export function isOwner(): boolean {
  return state.role === ROLES.OWNER;
}

export function isFriend(): boolean {
  return state.role === ROLES.FRIEND;
}
